import { render, staticRenderFns } from "./OfficialLeague.vue?vue&type=template&id=9d8efad6&"
import script from "./OfficialLeague.vue?vue&type=script&lang=js&"
export * from "./OfficialLeague.vue?vue&type=script&lang=js&"
import style0 from "./OfficialLeague.vue?vue&type=style&index=0&id=9d8efad6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports